import { FilterConfig } from 'common/models/filter.model';
import { FILTER_ITEMS } from './constants-filter-configs';

export const PLANNING_FILTER: FilterConfig[] = [FILTER_ITEMS.planningDateRange];
